import { useMemo } from 'react';

import { useTableStoreSelector } from 'components/table/hooks/context';
import { IDataPaging, IResult, IResultPaged } from 'types/api/common';
import { isPagingData, isResult, isResultPaged } from 'utilities/results';

export const usePagingData = <TData>(
  dataSource: TData[] | IResult<TData[]> | IResultPaged<TData[]> | (IDataPaging & IResult<TData[]>) | null
) => {
  const page = useTableStoreSelector((state) => state.page);
  const pageSize = useTableStoreSelector((state) => state.pageSize);

  return useMemo(() => {
    const isArray = Array.isArray(dataSource);
    const isApiResult = isResult(dataSource);
    const isApiResultPaged = isResultPaged(dataSource);
    const isApiPagingData = isPagingData(dataSource);
    let data: TData[] = [];
    let pageCount = 0;
    let sort: string | undefined;
    let total = 0;

    if (isArray) {
      data = dataSource;
      total = data.length;
    }

    if (isApiResult) {
      const { dataContainer } = dataSource;

      if (Array.isArray(dataContainer)) {
        data = dataContainer;
      } else {
        data = dataContainer?.data ?? [];
      }

      total = data.length;
    }

    if (isApiResultPaged) {
      const { dataContainer } = dataSource;

      ({ data, numberOfPages: pageCount, sort, total } = dataContainer);
    }

    if (isApiPagingData) {
      data = dataSource.dataContainer ?? [];
      ({ numberOfPages: pageCount, sort, total } = dataSource);
    }

    return {
      data,
      manualPagination: isApiResultPaged || isApiPagingData,
      page,
      pageCount,
      pageSize,
      sort,
      total,
    } as const;
  }, [dataSource, page, pageSize]);
};
